module.exports = __webpack_public_path__ + "static/media/button-x.245027fc.svg";